/**
 * Đơn Pháp Bảo (Thanh Tịnh Pháp — Đơn Pháp Bảo) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const SacredFormTemplatesPage = lazy(() =>
  import("@/features/sacred-forms").then((mod) => ({ default: mod.SacredFormTemplatesPage })),
);
const SacredFormApplicantsPage = lazy(() =>
  import("@/features/sacred-forms").then((mod) => ({ default: mod.SacredFormApplicantsPage })),
);
const DisposalPolarityPage = lazy(() =>
  import("@/features/sacred-forms/disposal-polarity-page").then((mod) => ({ default: mod.DisposalPolarityPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const sacredFormTemplatesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/don-phap-bao/mau-don",
  component: withSuspense(SacredFormTemplatesPage),
});
const sacredFormApplicantsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/don-phap-bao/don-dang-ky",
  component: withSuspense(SacredFormApplicantsPage),
});
const disposalPolarityRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/don-phap-bao/quy-tac-xu-ly",
  component: withSuspense(DisposalPolarityPage),
});

export const donPhapBaoRoutes = [
  sacredFormTemplatesRoute,
  sacredFormApplicantsRoute,
  disposalPolarityRoute,
];
